const choices = {
    card: 'Carte Bancaire',
    iban: 'Iban',
};

export default choices;
